import $ from 'jquery';

$(function () {
  var AccountsTable = function () {
    this.section = $('section.accounts');
    this.form = this.section.find('#employee_search');
    this.nameSearchInput = this.form.find('.js-search-input');
    this.managerSearchInput = this.form.find('.js-manager-filter');
    this.deactivatedCheckbox = this.form.find('.js-show-deactivated');
    this.nameSearchTimeout = null;
  };

  AccountsTable.prototype.init = function () {
    this.bindNameSearch();
    this.bindManagerSearch();
    this.bindDeactivatedCheckbox();
    this.bindRemoteUpdates();
  };

  AccountsTable.prototype.submitSearch = function () {
    var self = this;

    self.section.find('.tab-pane.active').empty().append('<div class="loading-indicator">');

    $.ajax({
      url: self.form.attr('action'),
      method: self.form.attr('method') || 'GET',
      data: self.form.serialize(),
      dataType: 'json',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .done(function (payload) {
        if (payload && Object.prototype.hasOwnProperty.call(payload, 'html')) {
          self.applyResponse(payload);
        }
      })
      .always(function () {
        self.section.find('.loading-indicator').remove();
      });
  };

  AccountsTable.prototype.bindNameSearch = function () {
    var self = this;

    self.form.on('submit', function (event) {
      event.preventDefault();
      clearTimeout(self.nameSearchTimeout);
      self.submitSearch();
    });

    self.nameSearchInput.on('input', function () {
      clearTimeout(self.nameSearchTimeout);

      self.nameSearchTimeout = setTimeout(function () {
        self.submitSearch();
      }, 500);
    });
  };

  AccountsTable.prototype.bindManagerSearch = function () {
    var self = this;

    // The manager filter is rendered as a Rails `<select>` wrapped in
    // `.js-legacy-alchemy-select`. `LegacyAlchemySelect` writes back to the
    // underlying `<select>` and dispatches a native `change` event, which we
    // listen for directly.
    self.managerSearchInput.on('change', function () {
      clearTimeout(self.nameSearchTimeout);
      self.submitSearch();
    });
  };

  AccountsTable.prototype.bindDeactivatedCheckbox = function () {
    var self = this;

    self.deactivatedCheckbox.on('input', function () {
      clearTimeout(self.nameSearchTimeout);
      self.submitSearch();
    });
  };

  AccountsTable.prototype.applyResponse = function (payload) {
    var self = this;
    var section = self.section;

    section.find('.nav-tabs li').removeClass('active');
    section.find('.js-tab-count').removeClass('hidden');
    section
      .find('.js-results-count')
      .addClass('hidden')
      .text('(' + payload.total_count + ')');

    self.deactivatedCheckbox.prop('checked', payload.show_deactivated);

    var activeTab = section.find('.nav-tabs li[data-tab="' + payload.type + '"]');
    activeTab.addClass('active');
    activeTab.find('.js-tab-count').addClass('hidden');
    activeTab.find('.js-results-count').removeClass('hidden');

    if (!payload.group_id) {
      var option = self.managerSearchInput.find('option[selected]');
      if (option.length) {
        option.prop('selected', false);
      }
      self.managerSearchInput.val('');
      // Keep the Alchemy-backed select's UI in sync with the reset value.
      var managerSelectEl = self.managerSearchInput.get(0);
      if (managerSelectEl) {
        managerSelectEl.dispatchEvent(new CustomEvent('legacyAlchemySelect:sync'));
      }
    }

    self.form.attr('action', payload.form_action);
    self.nameSearchInput.val(payload.search_value);
    section.find('.tab-pane.active').html(payload.html);
    section.find('a[data-remote]').attr('data-type', 'json');
  };

  AccountsTable.prototype.bindRemoteUpdates = function () {
    var self = this;

    self.section.on('ajax:complete', function (evt) {
      const [xhr] = evt.detail || [];
      if (!xhr || xhr.status !== 200) {
        return;
      }

      var payload;
      try {
        payload = JSON.parse(xhr.responseText);
      } catch (e) {
        return;
      }

      if (!payload || !Object.prototype.hasOwnProperty.call(payload, 'html')) {
        return;
      }

      self.applyResponse(payload);
    });
  };

  if ($('body.accounts.index').length >= 1) {
    new AccountsTable().init();
  }
});
